<div *ngIf="faq" class="container-fluid">
  <div mat-dialog-title>
    <h4 *ngIf="faq.supportFaq_ID" class="pl-3">Edit FAQ</h4>
    <h4 *ngIf="!faq.supportFaq_ID" class="pl-3">Add FAQ</h4>
  </div>
  <div class="form-inline mb-2">
    <span *ngIf="faq.supportFaq_ID">To edit your FAQ information, update the form below then click Submit</span>
    <span *ngIf="!faq.supportFaq_ID">To add FAQ information, update the form below then click Submit</span>
    <span class="ms-2 warning">
      * Required Information
    </span>
  </div>
  <form #form="ngForm" (ngSubmit)="saveFaq(form)">
    <div class="form-group form-inline pr-2">
      <label class="pr-2" for="supportFaq_Locale">Locale</label>
      <div>
        <select name="supportFaq_Locale" class="form-control select-bidit" [(ngModel)]="faq.supportFaq_Locale">
          <option value="en">English</option>
          <option value="es">Español</option>
        </select>
      </div>
    </div>
    <div mat-dialog-content>
      <div class="row pl-3">
        <div class="form-group form-inline pr-2">
          <span class="warning">* </span>
          <label class="pr-2" for="supportFaq_Title">Category</label>
          <div>
            <quill-editor theme="snow" [(ngModel)]="faq.supportFaq_Title" name="supportFaq_Title"
                          id="supportFaq_Title" class="col-sm-8"
                          required #title="ngModel"
                          [class.field-error]="form.submitted && title.invalid"></quill-editor>
            <div [hidden]="!form.submitted || title.valid"
                 class="alert alert-danger">
              Enter a title for the FAQ
            </div>
          </div>
        </div>
      </div>

      <div class="form-group form-inline pr-2">
        <span class="warning">* </span>
        <label class="pr-2" for="supportFaq_Content">Content</label>
        <div>
          <quill-editor theme="snow" [(ngModel)]="faq.supportFaq_Content" name="supportFaq_Content"
                        id="supportFaq_Content" class="col-sm-8"
                        required #content="ngModel"
                        [class.field-error]="form.submitted && content.invalid"></quill-editor>
          <div [hidden]="!form.submitted || content.valid"
               class="alert alert-danger">
            Enter content for the FAQ
          </div>
        </div>
      </div>
      <div class="form-group form-inline pr-2">
        <table class="table table-bidit" cdkDropList
                   [cdkDropListData]="this.faq.hyperlinks"
                   (cdkDropListDropped)="drop($event)">
          <thead>
            <tr>
              <th i18n>Description</th>
              <th i18n>Path</th>
              <th i18n></th>
            </tr>
          </thead>
          <tbody>
            <!--<ng-template [ngIf]="faq.hyperlinks">-->
              <tr *ngIf="faq.hyperlinks?.length==0">
                <td colspan="3" i18n>No defined links for selected FAQ</td>
              </tr>
              @for (hyperlink of this.faq.hyperlinks; track hyperlink ){
             
              <tr id="hyperlink_supportFaqHyperlink_ID" cdkDrag >
                <td>
                  <input name="hyperlink_description{{hyperlink.supportFaqHyperlink_ID}}" class="form-control"
                         [(ngModel)]="hyperlink.supportFaqHyperlink_Description" required />
                  <div [hidden]="!form.submitted || hyperlink.supportFaqHyperlink_Description" class="alert alert-danger" i18n>Enter a description</div>
                </td>
                <td>
                  <input name="hyperlink_path{{hyperlink.supportFaqHyperlink_ID}}" class="form-control w-100"
                         [(ngModel)]="hyperlink.supportFaqHyperlink_Path" required />
                  <div [hidden]="!form.submitted || hyperlink.supportFaqHyperlink_Path" class="alert alert-danger" i18n>Enter a path</div>
                </td>
                <td>
                  <button type="button" class="btn btn-bidit-delete"
                          (click)="removeHyperlink(hyperlink)" title="Remove hyperlink" i18n-title></button>
                </td>
              </tr>
            }
            <tr>
              <td colspan="2" i18n>Add FAQ link</td>
              <td>
                <button type="button" class="btn btn-bidit-add" (click)="addHyperlink()" title="Add FAQ link" i18n-title></button>
              </td>
            </tr>
          </tbody>
        </table>
    </div>
</div>
<mat-dialog-actions align="end">
  <button type="submit" value="submit" name="submit" id="submit" class="btn btn-bidit-submit btn-md mr-3" [disabled]="isRequesting">Submit</button>
  <a (click)="onNoClick()" class="btn btn-bidit-cancel btn-md">Cancel</a>
</mat-dialog-actions>
<app-spinner [isRunning]="isRequesting"></app-spinner>

<div class="mt-3">
  <div [hidden]="!form.submitted || form.valid"
       class="alert alert-danger">
    Validation issues encountered.  Please review your entered information.
  </div>
</div>
    </form>
</div>
